import React, { Component } from 'react';
import CSSModules from 'helpers/CSSModulesUtil';
import styles from './styles.scss';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { projectValueSelector } from 'containers/Project/GreenlightReport/selectors';
import ReportBody from '../../TestReport/ReportBody';
import ReportHeader from '../ReportHeader';
import T from 'i18n-react'

const mapStateToProps = (state) => {
 return {
    tests: projectValueSelector(state)
 }
}

class AggregateTestReports extends Component {
 render(){
  const {
   tests
  } = this.props
  return(
   <div>
    {tests.map((test, index) => (
     <div styleName='testReportContainer' key={index}>
       <ReportHeader
         title={
           T.translate(
             `finalReport.tests.${test.testName}`,
             { notFound: 'Test' }
           )
         }
       />
       <ReportBody test={test}/>
     </div>
    ))}
   </div>
  );
 }
}

const withStyles = CSSModules(styles);
const withConnect = connect(mapStateToProps);
const enhance = compose(withConnect, withStyles);
export default enhance(AggregateTestReports);
